import { divIcon } from 'leaflet';
import { ElementType, FC, PropsWithChildren } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { Marker, MarkerProps } from 'react-leaflet';
import { useDynamicModule } from '../../hooks';
import { PortalWidgetIcons } from '../icons';
import { MapMarker, MapMarkerProps } from './map-marker';

interface Props extends MapMarkerProps {
  icon: string;
}

interface MarkerContainerProps extends MarkerProps, PropsWithChildren { }

export const DynamicMapMarker: FC<Props> = ({ icon, ...props }) => {
  const { module, loaded } = useDynamicModule<Record<string, ElementType<any>>>('feature-icons', PortalWidgetIcons);

  const DynamicIcon = module?.[icon];

  if (!loaded || !DynamicIcon) {
    return <MapMarker {...props} />;
  }

  return <MapMarker {...props} icon={<DynamicIcon />} />;
};

export const MarkerContainer: FC<MarkerContainerProps> = ({ children, ...props }) => {
  const generatedMarker = renderToStaticMarkup(<>{children}</>);

  const component = divIcon({
    html: generatedMarker,
    iconSize: [30, 30],
  });

  return <Marker {...props} icon={component} />;
};
